module.exports = __webpack_public_path__ + "media/images/bg_radar-233e86661a43275803582431404485b7.png";